var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 39.9999C31.0461 39.9999 40.0004 31.0456 40.0004 19.9999C40.0004 8.95418 31.0461 -0.00012207 20.0004 -0.00012207C8.95472 -0.00012207 0.000411987 8.95418 0.000411987 19.9999C0.000411987 31.0456 8.95472 39.9999 20.0004 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 -6.10352e-05C11.401 -6.10352e-05 4.07012 5.42744 1.24426 13.0435H38.7564C35.9304 5.42744 28.5996 -6.10352e-05 20.0003 -6.10352e-05V-6.10352e-05Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 39.9999C28.5996 39.9999 35.9304 34.5724 38.7563 26.9564H1.24426C4.07012 34.5724 11.401 39.9999 20.0003 39.9999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9501 15.2173L13.0293 18.5385H16.5217L13.6963 20.5915L14.7755 23.9129L11.9501 21.8602L9.12476 23.9129L10.204 20.5915L7.37859 18.5385H10.871L11.9501 15.2173Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0497 15.2173L29.1289 18.5385H32.6214L29.7959 20.5915L30.8751 23.9129L28.0497 21.8602L25.2243 23.9129L26.3036 20.5915L23.4782 18.5385H26.9706L28.0497 15.2173Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyria);
export default __webpack_public_path__ + "static/media/syria.65d75a6b4295413f5a0332a7aba40fb7.svg";
export { ForwardRef as ReactComponent };